<script>
  // import closeMixin from '../mixins/close.js';

  import Vue from "vue";
  Vue.directive("click-outside", {
    bind(el, binding, vnode) {
      el.clickOutsideEvent = (event) => {
        if (!(el === event.target || el.contains(event.target))) {
          vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind(el) {
      document.body.removeEventListener("click", el.clickOutsideEvent);
    },
  });

  export default {
    // mixins: [closeMixin],
    name: 'Menu',
    props: ['width'],
    data(){
      return {
        isOpen: false,
      }
    },
    mounted(){
      // Que la modale récupère le focus au démarrage pour que l'évènement 'ESC' soit capté.
      // document.getElementById("menu").focus() //ça fout une bordure dégueulasse....
      for (const item of document.getElementById('menu' + this.width).childNodes) {
        item.style.width = this.width
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      onClickOutside() {
        if (this.isOpen){
          this.$emit('close');
        } else {
          this.isOpen = true
        }
      },
    },
  };
</script>

<template>
    <transition name="modal-fade" appear="">
        <div class="menuModal" v-click-outside="onClickOutside" @keydown="close()" tabindex="0" :id="'menu' + width">
          <slot name="body">
            <div class="noRes">Aucun élément...</div>
          </slot>
        </div>
    </transition>
</template>

<style lang="scss">
@import '../assets/main.scss';

  .menuModal{
    min-width: 100px;
    background-color: white;
    border-radius: 3px;
    box-shadow: 1px 1px 10px 2px rgba(50, 50,50, 0.5);
    position: absolute;
    z-index: 50;
    padding: 10px 0;

    //Style des éléments du menu intégrés dans le parent
    & div{
      height : 32px;
      padding: 0 10px;
      display: flex;
      align-items: center;

      &:hover{
        background-color: rgba($color: $main, $alpha: 0.05);
        cursor: pointer;
      }

      & .material-icons{
        margin: 0 10px 0 0;
        &:hover{
          color: $black-bolder;
        }
      }
    }
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: all 0.3s ease;
  }

  .noRes{
    @include myFont;
    font-size: 13px;
  }

</style>